import * as React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { connect } from "react-redux";
import { GlobalState } from "../../store";
import * as actions from "../../store/cases/actions";
import { Case, User, Category, Tag } from "../../api/classes";
import CaseListItem from "../../pages/cases/caseListItem";
import { List, TextField, IconButton, Typography } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import CategorySelect from "../categorySelect";
import FolderSelect from "../folderSelect";
import * as constants from "../../api/constants";
import FilterView from "../filter";
import { DubitoSvc } from "src/api";

interface Props {
  open: boolean;
  onClose: () => void;
  onCreate: (text: string) => void;
}

class CreateMessageTemplateDialog extends React.Component<Props> {
  state = {
    open: this.props.open,
    scroll: "paper",
    text: "",
    creating: false
  };
  componentWillReceiveProps(next: Props) {
    if (!this.props.open && next.open) {
      this.setState({ open: next.open });
    }
  }

  handleCreate = () => {
    this.setState({ creating: true });
    DubitoSvc.createMessageTemplate({
      text: this.state.text
    }).then(res => {
      this.setState({ creating: false });
      this.props.onCreate(this.state.text);
      // this.props.onCreate(res.id);
    });
  };
  handleClose = () => {
    if (this.state.creating) {
      return;
    }
    this.setState({ open: false, query: "" });
    this.props.onClose();
  };

  render() {
    return (
      <div>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          scroll={"paper"}
          aria-labelledby="scroll-dialog-title"
          maxWidth="sm"
          fullWidth
          PaperProps={{
            style: { height: "100%" }
          }}
          style={{ height: "100%" }}
        >
          <DialogTitle id="scroll-dialog-title">
            <div style={{ display: "flex", alignItems: "center" }}>
              <span style={{ flex: 1 }}>Create a Message Template</span>
            </div>
          </DialogTitle>
          <DialogContent>
            <TextField
              placeholder="Message"
              autoFocus
              value={this.state.text}
              onChange={e => this.setState({ text: e.target.value })}
              style={{ width: "100%" }}
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button
              disabled={this.state.creating}
              onClick={this.handleClose}
              color="primary"
            >
              Cancel
            </Button>
            <Button
              disabled={this.state.creating}
              onClick={this.handleCreate}
              color="primary"
            >
              Create
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default connect(
  (state: GlobalState, own: Props) => ({}),
  dispatch => ({})
)(CreateMessageTemplateDialog);



// WEBPACK FOOTER //
// ./src/components/dialogs/createMessageTemplate.tsx